// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const FileJpgIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path d="M19 11C19 10.182 19 9.43 18.848 9.063C18.696 8.696 18.407 8.406 17.828 7.828L13.092 3.092C12.593 2.593 12.344 2.344 12.034 2.196C11.9698 2.16518 11.9041 2.13781 11.837 2.114C11.514 2 11.161 2 10.456 2C7.211 2 5.588 2 4.489 2.886C4.26709 3.06494 4.06494 3.26709 3.886 3.489C3 4.59 3 6.211 3 9.456V14C3 17.771 3 19.657 4.172 20.828C5.344 21.999 7.229 22 11 22H19M12 2.5V3C12 5.828 12 7.243 12.879 8.121C13.757 9 15.172 9 18 9H18.5" stroke={color || '#141414'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 15C21 14.7348 20.8946 14.4804 20.7071 14.2929C20.5196 14.1054 20.2652 14 20 14H18.5C18.2348 14 17.9804 14.1054 17.7929 14.2929C17.6054 14.4804 17.5 14.7348 17.5 15V18C17.5 18.2652 17.6054 18.5196 17.7929 18.7071C17.9804 18.8946 18.2348 19 18.5 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17H20M10.5 14V17.25C10.5 17.7141 10.3156 18.1592 9.98744 18.4874C9.65925 18.8156 9.21413 19 8.75 19H8.667C7.747 19 7 18.254 7 17.333M12.5 19V17M12.5 17V15C12.5 14.7348 12.6054 14.4804 12.7929 14.2929C12.9804 14.1054 13.2348 14 13.5 14H14C14.3978 14 14.7794 14.158 15.0607 14.4393C15.342 14.7206 15.5 15.1022 15.5 15.5C15.5 15.8978 15.342 16.2794 15.0607 16.5607C14.7794 16.842 14.3978 17 14 17H12.5Z" stroke={color || '#141414'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { FileJpgIcon };
